import { FormattedMessage } from "react-intl";

import {
  FunctionalCard,
  FunctionalCardContent,
} from "@ps-design-system/components/cards/FunctionalCard";
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "@ps-design-system/components/Popover";
import { Text } from "@ps-design-system/components/Text";
import QuestionIcon from "@ps-design-system/icons/Question/Question16";
import XIcon from "@ps-design-system/icons/X/X16";

import { TAX_DETAILS_BANNER_MESSAGES } from "./TaxDetailsBanner.messages";

/** The popover's body, split out to keep the JSX nesting shallow. */
const InvalidPopoverBody = () => {
  return (
    <FunctionalCardContent className="tw-flex tw-gap-12">
      <div className="tw-flex tw-flex-col tw-gap-16">
        <Text>
          <FormattedMessage
            id="tax_details.tax_details_banner_description.popover_text_1"
            defaultMessage="Contact your national tax authority to register your VAT ID for intra-community (EU-wide) trade."
          />
        </Text>
        <Text>
          <FormattedMessage
            id="tax_details.tax_details_banner_description.popover_text_2"
            defaultMessage="Once you've done that, we'll handle the rest and update your status automatically once your tax authority processes the registration."
          />
        </Text>
      </div>
      <div>
        <PopoverClose>
          <XIcon />
          <span className="tw-sr-only">
            <FormattedMessage {...TAX_DETAILS_BANNER_MESSAGES.close} />
          </span>
        </PopoverClose>
      </div>
    </FunctionalCardContent>
  );
};

/** Renders the help popover explaining how to resolve an invalid VAT ID. */
const TaxDetailsBannerInvalidPopover = () => {
  return (
    <Popover>
      <PopoverTrigger>
        <QuestionIcon className="tw-text-gray-600 tw-inline" />
        <span className="tw-sr-only">
          <FormattedMessage {...TAX_DETAILS_BANNER_MESSAGES.moreInformation} />
        </span>
      </PopoverTrigger>
      <PopoverContent align="start" className="tw-w-[280px]">
        <FunctionalCard>
          <InvalidPopoverBody />
        </FunctionalCard>
      </PopoverContent>
    </Popover>
  );
};

export { TaxDetailsBannerInvalidPopover };
